module.exports = __webpack_public_path__ + "static/img/shui-2.b1da7c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuiBrand/shui-2.png
// module id = KhpA
// module chunks = 0